<script>

</script>

<main>
    <div class=" bg-blue-200 font-mono text-center m-5 p-8 border border-black">
        <h1 class=" font-bold text-3xl ">Embedify, create discord embeds with ease</h1>
        <p class=" text-xl">
            This web app helps you construct discord embeds to send to your server or a friend's 
        </p>
        <p class=" text-xl">
            Simply put the webhook url and at least one of the fields [except for the username unless you wanna override the username set in your webhook settings] then hit send 
        </p>
        <p class=" text-xl">
            Support the project by starring the repo and feel free to join the discord server to hang or talk about js 
        </p>
        <div class=" space-x-4 mt-6">
            <a href="https://github.com/ilovebewbs/embidify" target="_blank">
            <button class=" bg-gray-500 text-white px-4 py-4 font-bold rounded-2xl hover:bg-gray-700">
                Github repo
            </button>
            </a>
            <a href="https://discord.gg/uC3aQ8J59m" target="_blank">
            <button class=" bg-purple-500 text-white px-4 py-4 font-bold rounded-2xl hover:bg-purple-800">
                Discord server 
            </button>
            </a>
        </div>
    </div>
</main>

<style>

</style>